import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Item } from '../models/item.model';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class ItemService {

  private _items: BehaviorSubject<Item[]> = new BehaviorSubject([]);
  public readonly items: Observable<Item[]> = this._items.asObservable();

  constructor(private api: ApiService) {
    this.loadItems();
  }

  loadItems() {
    this.api.getSharedItems().subscribe((items: Item[]) => this._items.next(items));
  }

}
